import React from "react";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useCustomController } from "components/Reusable/Form/useCustomController.js";

const CustomPhoneField = (props) => {
  const { getTextByKey } = useContent();

  const { fieldControls } = useCustomController(props);


  const handleChangePhone = (e) => {
    //allow only numbers,+,-,()
    const lettersRegex = /^[0-9()+-]*$/;

    if (e.match(lettersRegex)) {
      fieldControls.onChange(e);
    } else if (e === "" || e === null) {
      fieldControls.onChange(e);
    }
    //check if e validate
  };

  return (
    <div className="phoneInput-container">
      <div className="label-field">
        {getTextByKey("profileuserdetails-mobilephone")}
      </div>
      <input
        className="phone-input"
        onChange={(e) => handleChangePhone(e.target.value)}
        value={
          fieldControls ? (fieldControls.value ? fieldControls.value : "") : ""
        }
      />
    </div>
  );
};

export default CustomPhoneField;
